import SchoolExamPeriodAPI from '@/apis/business/teacher/school-exam-period-api.js'
import SchoolExamAssignAPI from '@/apis/business/teacher/school-exam-assign-api.js'
import StudentClassroomAPI from '@/apis/business/teacher/student-classroom-api.js'
import SchoolExamPeriodDetailAPI from '@/apis/business/teacher/school-exam-period-detail-api.js'
import StudentExamAPI from '@/apis/business/teacher/student-exam.js'
import { Pagination } from '@/common/constant'
import enumeration from '@/common/enumeration'
import { localStorageKeys } from '@/common/storage-keys'
import { localStorage } from '@/utils/storage'
import cloneDeep from 'lodash/cloneDeep'

export default {
  namespaced: true,

  state: {
    schoolExamPeriods: null,
    schoolExamPeriod: {},
    // school exam assign
    teachers: [],
    schoolExamAssigns: [],
    schoolAssignIds: {},
    // teachers: {},
    listClass: {},
    listExamPeriodClassroom: [],
    // PBac
    listExamAssign: [], // Danh sách bài kiểm tra được phân công chấm
    schoolExamPeriodDetailOverviews: [], // Danh sách bài kiểm tra Xem ở màn tổng quan
    schoolExamPeriodMarkingProgresss: [], // Danh sách bài kiểm tra Xem ở màn tổng quan
    totalExamAssign: null,
    examperiodFilterOverview: {
      monthFilter: new Date().getMonth() + 1, // Tìm kiếm theo tháng mạc định là tháng hiện tại nhưng chưa lấy được
      gradeFilter: undefined, // Tìm kiếm theo khối
      subjectFilter: '', // Tìm kiếm theo môn
      statusFilter: enumeration.StatusSchoolExamPeriodFilter.All, // Tìm kiếm theo trạng thái
      openTimeFilter: null // Tìm kiếm theo ngày mở đề
    },
    examperiodFilterMarkingProgress: {
      monthFilter: new Date().getMonth() + 1,
      gradeFilter: undefined, // Tìm kiếm theo khối
      subjectFilter: '', // Tìm kiếm theo môn
      openTimeFilter: null // Tìm kiếm theo ngày mở đề
    },
    currentMonthAfterSave: 0,
    listStudentToParticipate: [],
    listLastExam: [],
    listStudentPicked: [],
    isChangeScope: true,
    listStudentLastPicked: [],
    totalStudentToParticipate: 0 // Tổng số học sinh chưa được chọn
  },

  getters: {
    schoolExamPeriods (state) {
      let schoolExamPeriods = []
      const data = state.schoolExamPeriods
      // nối subject thành 1 chuỗi
      for (let i = 0; i < data?.length; i++) {
        let subjects = ''
        data[i]?.Subjects?.forEach(item => {
          subjects += item.SubjectName + ', '
        })
        subjects = subjects.slice(0, subjects.length - 2)
        data[i].SubjectList = subjects
      }

      schoolExamPeriods = JSON.parse(JSON.stringify(data))
      return schoolExamPeriods?.sort((a, b) => {
        if (a.SchoolYearExam > b.SchoolYearExam) return -1
        if (a.SchoolYearExam < b.SchoolYearExam) return 1
        if (a.Month > b.Month) return 1
        if (a.Month < b.Month) return -1
      })
    }
    // schoolExamPeriods (state) {
    //   const schoolExamPeriods = []
    //   const data = state.schoolExamPeriods

    //   for (var i = 0; i < data?.length; i++) {
    //     const schoolExamPeriodByMonth = schoolExamPeriods?.filter(
    //       (x) => x.Month === data[i].Month
    //     )
    //     // kiểm tra tháng của kỳ đánh giá đã được tạo chưa
    //     if (schoolExamPeriodByMonth.length > 0) {
    //       let schoolExamPeriodByGrade =
    //         schoolExamPeriodByMonth[0]?.Data?.filter(
    //           (x) => x.GradeID === data[i]?.GradeID
    //         )
    //       // Kiểm tra khối của kỳ đánh giá đã được tạo chưa
    //       if (schoolExamPeriodByGrade.length > 0) {
    //         const tmp = {
    //           Id: data[i]?.Id,
    //           Subjects: data[i]?.Subjects,
    //           ToDate: data[i]?.ToDate,
    //           FromDate: data[i]?.FromDate,
    //           Title: data[i]?.Title
    //         }
    //         schoolExamPeriodByGrade[0].ListAssessment?.push(tmp)
    //       } else {
    //         const tmp = {
    //           Id: data[i]?.Id,
    //           Subjects: data[i]?.Subjects,
    //           ToDate: data[i]?.ToDate,
    //           FromDate: data[i]?.FromDate,
    //           Title: data[i]?.Title
    //         }
    //         schoolExamPeriodByGrade = {
    //           GradeID: data[i]?.GradeID,
    //           GradeIDName: data[i]?.GradeName,
    //           ListAssessment: [tmp]
    //         }
    //         schoolExamPeriodByMonth[0].Data?.push(schoolExamPeriodByGrade)
    //       }
    //     } else {
    //       const tmp = {
    //         Id: data[i]?.Id,
    //         Subjects: data[i]?.Subjects,
    //         ToDate: data[i]?.ToDate,
    //         FromDate: data[i]?.FromDate,
    //         Title: data[i]?.Title
    //       }
    //       const schoolExamPeriodByGrade = {
    //         GradeID: data[i]?.GradeID,
    //         GradeIDName: data[i]?.GradeName,
    //         ListAssessment: [tmp]
    //       }
    //       console.log(data[i])
    //       const schoolExamPeriodByMonth = {
    //         Month: data[i]?.Month,
    //         Data: [schoolExamPeriodByGrade],
    //         SchoolYearExam: new Date(data[i]?.FromDate).getFullYear()
    //       }
    //       schoolExamPeriods?.push(schoolExamPeriodByMonth)
    //     }
    //   }
    //   return schoolExamPeriods?.sort((a, b) => {
    //     if (a.SchoolYearExam > b.SchoolYearExam) return -1
    //     if (a.SchoolYearExam < b.SchoolYearExam) return 1
    //     if (a.Month > b.Month) return -1
    //     if (a.Month < b.Month) return 1
    //   })
    // }
  },

  mutations: {
    /**
     * Clone dữ liệu kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriods (state, data) {
      state.schoolExamPeriods = data
    },
    /**
     * Dữ liệu chi tiết một bản ghi kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriod (state, data) {
      state.schoolExamPeriod = data
    },

    setSchoolExamPeriodByReference (state, params) {
      state.schoolExamPeriod[params.name] = params.value
    },

    setSchoolExamPeriodClassroomsForEdit (state, params) {
      state.schoolExamPeriod.Classrooms = params
      state.isChangeScope = !state.isChangeScope
    },

    /**
     * Dữ liệu chi tiết một bản ghi kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriodClassrooms (state, data) {
      state.listExamPeriodClassroom = data
    },

    /**
     * Thêm dữ liệu sau khi thêm kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    afterAddSchoolExamPeriod (state, data) {
      state.schoolExamPeriods.push(data)
    },
    // TODO: phần assign
    /**
     * Lấy dữu liệu giáo viên theo trường
     * @param {*} state
     * @param {*} teachers
     */
    setTeachers (state, teachers) {
      state.teachers = teachers
    },

    /**
     * gán giá trị cho danh sách giáo viên đc phân công chấm
     * @param {} state
     * @param {*} listTeacher
     */
    setSchoolExamAssigns (state, teachers) {
      state.schoolExamAssigns = teachers
    },

    /**
     * lấy giá trị id sau khi lưu mới
     * @param {} state
     * @param {*} listID
     */
    setSchoolExamAssignIds (state, Ids) {
      state.schoolAssignIds = Ids
    },

    setListExamAssign (state, listExamAssign) {
      state.listExamAssign = listExamAssign
    },

    /**
     * @author PVThang
     * @description set giá trị cho totalTeacherExam
     */
    setTotalExamAssign (state, newVal) {
      state.totalExamAssign = newVal
    },

    /**
     * @author VHSON
     * @description set giá trị cho schoolExamPeriodDetailOverviews
     */
    setSchoolExamPeriodDetailOverviews (state, schoolExamPeriodDetailOverviews) {
      state.schoolExamPeriodDetailOverviews = schoolExamPeriodDetailOverviews
    },

    /**
     * @author VHSON
     * @description set giá trị cho schoolExamPeriodMarkingProgresss
     */
    setSchoolExamPeriodMarkingProgresss (
      state,
      schoolExamPeriodMarkingProgresss
    ) {
      state.schoolExamPeriodMarkingProgresss = schoolExamPeriodMarkingProgresss
    },

    setCurrentMonthAfterSave (state, currentMonthAfterSave) {
      state.currentMonthAfterSave = currentMonthAfterSave
    },

    /**
     * @description Set dữ liệu vào state theo format append paging
     * @author PBac
     * @param {*} state
     * @param {*} listStudentToParticipate
     */
    setListStudentToParticipate (state, listStudentToParticipate) {
      if (state.listStudentToParticipate?.length === 0) {
        state.listStudentToParticipate = listStudentToParticipate
      } else {
        state.listStudentToParticipate = state.listStudentToParticipate.concat(listStudentToParticipate)
      }
    },

    /**
     * @description Set dữ liệu vào state  paging
     * @author VHSon
     * @param {*} state
     * @param {*} listStudentToParticipate
     */
    setTotalStudentToParticipate (state, totalStudentToParticipate) {
      state.totalStudentToParticipate = totalStudentToParticipate
    },

    /**
     * @description Reset dữ liệu danh sách học sinh
     * Sử dụng khi thay đổi các giá trị trên combo filter
     * @param {*} state
     */
    resetListStudentToParticipate (state) {
      state.listStudentToParticipate = []
    },

    /**
     * @description Set dữ liệu danh sách kỳ kiểm tra vào state
     * @author PBac
     * @param {*} state
     * @param {*} listLastExam
     */
    setListLastExam (state, listLastExam) {
      state.listLastExam = listLastExam
    },

    /**
     * @description Set dữ liệu danh sách học sinh tham gia
     * @author PBac
     * @param {*} state
     * @param {*} listStudentPicked
     */
    setListStudentPicked (state, listStudentPicked) {
      if (!listStudentPicked) {
        listStudentPicked = []
      }
      state.listStudentPicked = cloneDeep(listStudentPicked)
    },

    /**
     * @description Set dữ liệu danh sách học sinh tham gia gốc
     * @author VHSON
     * @param {*} state
     * @param {*} listStudentLastPicked
     */
    setListStudentLastPicked (state, listStudentLastPicked) {
      state.listStudentLastPicked = cloneDeep(listStudentLastPicked)
    }
  },

  actions: {
    getListTeacherByOrganizationId (context, id) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.getAsync('/list-teacher-organization?id=' + id)
          .then((res) => {
            context.commit('setTeachers', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * lấy danh sách giáo viên của trường đó ra
     */
    getsTeachersBySchoolExamPeriodDetailId (context, id) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.getAsync('/list-teacher-assign?id=' + id)
          .then((res) => {
            context.commit('setSchoolExamAssigns', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * thêm mới hoặc cập nhật phân công giáo viên chấm bài
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateSchoolExamAssigns (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.postAsync('update-school-exam', params)
          .then((res) => {
            context.commit('setSchoolExamAssignIds', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // TODO: phần khác

    /**
     * Lấy chi tiết kỳ đánh giá
     * @param {*} context
     * @param {*} param
     * NVHUY1 06/09/2021
     */
    getSchoolExamPeriod (context, param) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.getAsync('detail?id=' + param.SchoolExamPeriodID)
          .then((res) => {
            context.commit('setSchoolExamPeriod', res.Data)
            context.commit('setListStudentPicked', res.Data?.Students)
            context.commit('setListStudentLastPicked', res.Data?.Students)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách kỳ đánh giá
     * @param {*} context
     * @param {*} param
     * NVHUY1 04/09/2021
     */
    getSchoolExamPeriods (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.getAsync('get-school-exam-periods', {
          params: {
            ...params,
            SchoolYear: params.SchoolYear ? params.SchoolYear : '',
            Month: params.Month
              ? params.Month
              : localStorage.get(
                localStorageKeys.SCHOOL_EXAM_PERIOD_MONTH_FILTER
              )
          }
        })
          .then((res) => {
            context.commit('setSchoolExamPeriods', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách lớp học trong kỳ đánh giá
     * @param {*} context
     * @param {*} classroomParams
     * VHSON 04/09/2021
     */
    getSchoolExamPeriodClassrooms (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.getAsync('get-list-classroom?', { params })
          .then((res) => {
            context.commit('setSchoolExamPeriodClassrooms', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @description Gọi API Thêm mới kỳ đánh giá
     * @author NVHUY1
     * @param {*} context
     * @param {*} schoolExam
     * @returns
     */
    addSchoolExamPeriod (context, schoolExam) {
      if (schoolExam.Classrooms.length === 0) {
        schoolExam.Classrooms = schoolExam.ClassInGrades
      }
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.addSchoolExamPeriod(schoolExam)
          .then((res) => {
            if (res.IsSuccess) {
              schoolExam.Id = res.Data
              context.commit('afterAddSchoolExamPeriod', schoolExam)
              resolve(true)
            } else {
              reject(res.IsSuccess)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    updateSchoolExamPeriod (context, schoolExam) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.putAsync('scope', schoolExam)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    deleteSchoolExamPeriod (context, schoolExamPeriodID) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.deleteSchoolExamPeriod(schoolExamPeriodID)
          .then((res) => {
            context.commit('setSchoolExamPeriod', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getAssignExam (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.getAsync('list-exam-assign', { params: params })
          .then((res) => {
            const data = res?.Data
            context.commit(
              'setListExamAssign',
              params.pageIndex === Pagination.PageIndexDefault
                ? data
                : [...(context.state?.listExamAssign || []), ...(data || [])]
            )
            resolve({
              Data: {
                PageData: data
              }
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy tòan bộ chi tiết kỳ kiểm tra
     * @param {} context
     * @param {*} filterParam
     * @returns
     * @author VHSON
     */
    getListSchoolExamPeriodDetail (context, filterParam) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.getAsync('get-school-exam-periods-overview', {
          params: filterParam
        })
          .then((res) => {
            context.commit('setSchoolExamPeriodDetailOverviews', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy thông tin cho màn hình tình trạng chấm bài
     * @param {} context
     * @param {*} filterParam
     * @returns
     * @author VHSON
     */
    getListSchoolExamPeriodMarkingProgress (context, filterParam) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.getAsync('marking-progress', {
          params: filterParam
        })
          .then((res) => {
            context.commit('setSchoolExamPeriodMarkingProgresss', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách học sinh paging theo khối, lớp
     * @author PBac
     * @createdDate 1/4/2022
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getStudentByGradeAndClass (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync('by-grade', { params: params })
          .then(res => {
            context.commit('setListStudentToParticipate', res.Data.PageData)
            context.commit('setTotalStudentToParticipate', res.Data.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách kỳ kiểm tra 2 thàng gần đây
     * @author PBac
     * @createdDate 1/4/2022
     * @param {*} context
     * @returns
     */
    getLastExamPeriod (context) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync('get-last-items')
          .then(res => {
            context.commit('setListLastExam', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách học sinh paging theo kỳ kiểm tra
     * @author PBac
     * @createdDate 1/4/2022
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getStudentByExamPeriod (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync('by-exam-period', { params: params })
          .then(res => {
            context.commit('setListStudentToParticipate', res.Data.PageData)
            context.commit('setTotalStudentToParticipate', res.Data.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Tạo kỳ kiểm tra
     * @author PBac
     * @createdDate 4/4/2022
     * @param {*} context
     * @param {*} params
     * @returns
     */
    createSchoolExamPeriod (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodAPI.postAsync('exam-scope', params)
          .then((res) => {
            if (res.IsSuccess) {
              context.commit('afterAddSchoolExamPeriod', res.Data)
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
